ui-cms-footnote-list {
  display: block;
  font-family: var(--skin-font-family-primary, $font-family-sans-serif);
  position: relative;

  ol {
    color: $ui-grey-plus-1;
    list-style: none;
    margin: 0;
    padding: 0;

    &.ui-cms-footnote--white {
      color: $ui-white;
    }

    li {
      display: flex;
      font-family: var(--skin-font-family-primary, $font-family-sans-serif);
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 12px;

      div {
        color: $ui-grey-plus-1;
        font-size: 14px;
        line-height: 20px;
      }

      .indent {
        margin-right: 18px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
